import styled, { keyframes } from 'styled-components';
import { IRevisedTypo } from 'styles/revised-typo';

export const PointColored = styled.button`
	width: 100%;
	height: 70px;
	background-color: ${({ theme }) => theme.colors.revised.dark_blue2};
	color: ${({ theme }) => theme.colors.revised.point};
	${({ theme }) => theme.revised_typo.typo_18b};

	${({ theme }) => theme.common.flexCenter};
	gap: 10px;

	transition: 0.2s;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme }) => theme.colors.revised.point};
		color: ${({ theme }) => theme.colors.revised.dark_blue2};

		& > span > svg {
			fill: ${({ theme }) => theme.colors.revised.dark_blue2};
		}
	}
`;

export const Outlined = styled.button<{
	bg_color?: string;
	bg_color_hovered?: string;
	typo?: keyof IRevisedTypo;
}>`
	width: 100%;
	height: 60px;
	background-color: ${({ theme, bg_color }) => bg_color ?? theme.colors.gray.gray_white};
	border: 1px solid ${({ theme }) => theme.colors.revised.dark_blue};

	color: ${({ theme }) => theme.colors.revised.dark_blue};
	${({ theme, typo }) => theme.revised_typo[typo ?? 'typo_16m']};

	${({ theme }) => theme.common.flexCenter};

	transition: 0.2s;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme, bg_color_hovered }) =>
			bg_color_hovered ?? theme.colors.gray.gray05_bg};
	}
`;

const button_loading_spinner = keyframes`
	
	from {
	  transform: rotate(0turn);
	}
  
	to {
	  transform: rotate(1turn);
	}
  
`;

export const Loading = styled.span<{ color?: string }>`
	--color: ${({ color, theme }) => color ?? theme.colors.revised.dark_blue};

	width: 20px;
	height: 20px;
	margin: auto;
	border: 2px solid transparent;
	border-top-color: var(--color);
	border-radius: 50%;
	animation: ${button_loading_spinner} 1s ease infinite;
`;
